import State from "models/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {type: productType},
            imageRatio,
        },
    } = state

    return {
        imageRatio,
        productType,
    }
}

export default connect(mapStateToProps)
